import * as React from 'react';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import { BookingPriceBreakdown } from 'Services/Api/_HumanWritten/PricingService/PricingService';
import { pricingLineLabel } from './pricingLineLabels';

export interface PriceBreakdownPanelProps {
	breakdown: BookingPriceBreakdown | null;
	/** The header's own total, used only when the breakdown carries none. */
	total: number;
}

/**
 * The reconciling per-line view of a booking's total. Presentational only — it neither fetches nor owns
 * modal chrome, so it can sit beside the diagnostic panel as a tab of one modal rather than as a modal of
 * its own.
 */
export function PriceBreakdownPanel({ breakdown, total }: PriceBreakdownPanelProps) {
	const lines = breakdown?.lines ?? [];

	if (lines.length === 0) {
		return <p className="price-breakdown__empty">No breakdown is available for this booking.</p>;
	}

	return (
		<div className="price-breakdown">
			<ul className="price-breakdown__list">
				{lines.map(line => (
					<li className="price-breakdown__row" key={line.key}>
						<span className="price-breakdown__row-label">
							{pricingLineLabel(line.key, line.description)}
							{line.subText && <span className="price-breakdown__row-subtext">{line.subText}</span>}
						</span>
						<span className="price-breakdown__row-amount">
							{formatPriceDisplay(line.amount, false, true, true)}
						</span>
					</li>
				))}
			</ul>
			<div className="price-breakdown__total-row">
				<span className="price-breakdown__total-label">Total</span>
				<span className="price-breakdown__total-amount">
					{formatPriceDisplay(breakdown?.total ?? total, false)}
				</span>
			</div>
		</div>
	);
}
